// Pipes
export { CapitalizePipe } from './capitalize';
export { JsonDatePipe } from './json-date';
export { LpadPipe } from './lpad';
export { SafeHtmlPipe } from './safe-html';
export { SafeUrlPipe } from './safe-url';
export { TranslatePipe } from './translate';